import React from 'react'
import {CTA} from 'common/styleguide/CTA'
import {userAgentIsIOS} from 'lib/mobileDeviceChecks'

// Button that, when clicked, will either open the provided
// resource in our mobile app or redirect the user to
// the app store to download the app
export class OpenInAppButton extends React.PureComponent {
  static defaultProps = {
    buttonText: 'Open in App'
  }

  onClick = () => {
    const installLink = userAgentIsIOS()
      ? 'itms-apps://appstore.com/ridewithgpsbikecomputer'
      : 'http://play.google.com/store/apps/details?id=com.ridewithgps.mobile'

    const attemptedTime = Date.now()
    const idleTimeout = 10000
    const timeout = setTimeout(() => {
      const elapsed = Date.now() - attemptedTime
      if (elapsed < idleTimeout && document.hasFocus()) {
        window.location.href = installLink
      }
    }, 5000)
    const clear = () => {
      clearTimeout(timeout)
      window.removeEventListener('blur', clear)
      window.removeEventListener('unload', clear)
    }
    window.addEventListener('blur', clear)
    window.addEventListener('beforeunload', clear)
  }

  render () {
    const {buttonText, appLink, ...ctaProps} = this.props

    return (
      <CTA href={appLink} {...ctaProps} onClick={this.onClick}>
        {buttonText}
      </CTA>
    )
  }
}
